"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminBulkPinStickersRequestDto = exports.CreateContentReportRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const stickers_1 = require("../../constants/stickers");
class CreateContentReportRequestDto {}
exports.CreateContentReportRequestDto = CreateContentReportRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: stickers_1.MAX_CONTENT_REPORT_REASON_LENGTH,
  required: false
}), __metadata("design:type", String)], CreateContentReportRequestDto.prototype, "reason", void 0);
class AdminBulkPinStickersRequestDto {}
exports.AdminBulkPinStickersRequestDto = AdminBulkPinStickersRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: String,
  isArray: true,
  description: 'Moment (sticker) publicIds.'
}), __metadata("design:type", Array)], AdminBulkPinStickersRequestDto.prototype, "publicIds", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'true = pin ("Pinned by the Venue"), false = unpin.'
}), __metadata("design:type", Boolean)], AdminBulkPinStickersRequestDto.prototype, "pinned", void 0);
//# sourceMappingURL=ContentReportRequest.dto.js.map